module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "decorate"
  }, [_c('h1', [_vm._v(_vm._s(_vm.title))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-583bfd7c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/decorate/index.vue
// module id = 173
// module chunks = 1